<template>
  <div :class="[$style.container, 'logout_button']">
    <a
      :href="logoutUrl"
      :class="$style.logoutButton"
    >
      <img
        src="~@images/logout.svg"
        :alt="t('logout')"
        width="24"
        height="24"
      >
    </a>
  </div>
</template>

<script>
  export default {
    props: {
      logoutUrl: {
        type: String
      }
    },
    locales: {
      'en': {
        'logout': 'Log Out'
      },
      'ru': {
        'logout': 'Выйти'
      }
    }
  }
</script>

<style lang="scss" module>

  /**
   * Container
   */
  .container {
    display: flex;
  }

  /**
   * Logout button
   */
  .logoutButton {
    display: flex;
    align-items: center;
    padding: 0 22px;
  }
</style>



// WEBPACK FOOTER //
// src/components/LogoutButton.vue